<template>
  <DataTable v-model:filters="filters" :value="boardList" paginator :rows="10" dataKey="IDX" :loading="loading" :rowsPerPageOptions="[5, 10, 20, 50]" stripedRows selectionMode="single" @rowSelect="onRowSelect">
    <template #header>
      <div class="div_title2">
        <IconField>
          <InputIcon>
            <i class="pi pi-search" />
          </InputIcon>
          <InputText v-model="filters['global'].value" :placeholder="$t('menu.search')" size="small" />
        </IconField>
        <Button :label="$t('menu.search')" raised size="small" @click="this.search()" v-if="page !== 'adjustment'" />
      </div>
    </template>
    <template #empty > <div class="no-result">{{ $t('sentence.noResult') }}</div> </template>
    <template #loading> <div class="no-result">{{ $t('sentence.loading7') }}</div> </template>
    <span v-if="this.page === 'admin'">
      <Column header="No/등록일" field="IDX">
        <template #body="{ data }"> 
          <div class="div_center" >
            No {{ data.IDX }}<br>
            {{ this.api.getDateByFormat(data.REG_DATE, 'YYYY.MM.DD') }}
          </div>
        </template>
      </Column>
      <Column header="TYPE" field="REG_DATE">
        <template #body="{ data }">
          <div class="flex items-center gap-2">
            <span>{{ data.TYPE }}</span>
          </div>
        </template>
      </Column>
    </span>
    <span v-else-if="this.page === 'tip'">
      <Column header="No" field="IDX">
        <template #body="{ data }">
          <div class="div_center">
            {{ data.IDX }}<br>
          </div>
        </template>
      </Column>
    </span>
    <span v-else-if="this.page === 'adjustment'">
      <Column header="청구일" field="REG_DATE" />
      <Column :header="$t('menu.brand')" field="BRAND" />
      <Column :header="$t('menu.fPrice')" >
        <template #body="{ data }">
          <div >
            {{ data.FOREIGN_PRICE }} {{ data.CURRENCY }}
          </div>
        </template>
      </Column>
      <Column :header="결제금액($t('unit.won'))" >
        <template #body="{ data }">
          <div :style="String(data.PAY_PRICE).indexOf('-') === -1 ? '':'color:red'">
            {{ Number(data.PAY_PRICE).toLocaleString() }}
          </div>
        </template>
      </Column>
      <Column header="승인번호" field="APPROVAL" />
    </span>
    <span v-else>
      <Column header="idx" field="IDX">
        <template #body="{ data }">
          <div class="div_center">
            {{ page === 'blog' ? data.SEQ : data.IDX }}
          </div>
        </template>
      </Column>
      <Column field="REG_DATE" :header="$t('menu.regDate')" >
        <template #body="{ data }">
          <div class="div_center">
            {{ this.api.getDateByFormat(data.REG_DATE, 'YYYY.MM.DD') }}
          </div>
        </template>
      </Column>
    </span>
    <Column v-if="page !== 'adjustment'" :header="this.page === 'market' ? '상품명' : 'TITLE'" field="TITLE" >
      <template #body="{ data }">
        <div class="flex items-center gap-2">
          <span> {{ data.TITLE }}</span>
        </div>
      </template>
    </Column>
    <Column :exportable="false" style="min-width:155px;" v-if="this.page === 'admin' || this.page === 'trade' ">
      <template #body="{ data }">
        <Button icon="pi pi-pencil" outlined rounded @click="click({type:'edit', idx:data.IDX, contentType:data.TYPE})" raised size="small" />
        <Button icon="pi pi-copy" outlined rounded severity="success" @click="this.api.copyClipboard(`https://contents.geek9.kr/${data.TYPE}/${data.IDX}`)" raised size="small" />
        <Button icon="pi pi-trash" outlined rounded severity="danger" @click="click({type:'DELETE_BOARD', idx:data.IDX})" raised size="small" />
      </template>
    </Column>
  </DataTable>
  <!-- <div class="ad-container">
    <Adsense
      data-ad-client="ca-pub-6699354447815429" 
      data-ad-slot="8230887469"
      data-ad-format="horizontal"
      data-full-width-responsive="true">
    </Adsense>
  </div> -->
</template>
<script>
import { ref } from 'vue'
import { FilterMatchMode } from '@primevue/core/api'
import router from './router'
import { useI18n } from 'vue-i18n'

export default {
  mounted() {
    this.emitter.on('contentsTab', this.search)
    if(this.page === 'market' || this.page === 'tip' || this.page === 'logistic' || this.page === 'blog'  ) this.search()
    else if(this.page === 'adjustment') {
      this.boardList = this.list
    }
  },  
  unmounted() {
    this.emitter.off('contentsTab', this.search)
  },
  components: {
  },
  props: {
    page:String,
    list:[]
  },
  data() {
    return {
      boardList:[],
      contentType:{}
    }
  },
  setup() {
    const { t } = useI18n()

    const PAGE_LIST = {
      admin:'SELECT_BOARD',
      faq:'SELECT_BOARD_SUGGEST',
      tip:'SELECT_BOARD',
      logistic:'SELECT_BOARD',
      market:'SELECT_TRADE',
      trade:'SELECT_TRADE',
      blog:'SELECT_NOTICE'
    }
    const loading = ref(false)
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    })
    return {
      filters,loading, PAGE_LIST, t
    }
  },
  methods: {
    async onRowSelect(event) {
      if(this.page === 'adjustment') {
        this.emitter.emit('adjustmentPopup', event.data)
      } else {
        const link = document.createElement('a')
        let url 
        if(this.page === 'blog') url = event.data.CONTENT
        else url = this.api.BACKEND_URL + `/${event.data.TYPE}/${event.data.IDX}`
        
        link.href = url
        link.setAttribute('target', '_blank')
        document.body.appendChild(link)
        link.click()
      }
    },
    async search(param) {
      this.loading = true
      let type = undefined
      param === undefined ? type = this.PAGE_LIST[this.page] : type = param.type
      let p = {}
      p.type = type
      if(this.page === 'market' || this.page === 'trade') {
        p.contentType = 'market'
        p.useYn = 1
      } else if(this.page === 'tip' ) {
        p.contentType = 'blog'
        p.useYn = 1
      } else if(this.page === 'logistic' ) {
        p.contentType = 'logistics'
        p.useYn = 1
      } else if(this.page === 'blog' ) {
        p.noticeType = 'articles'
      }
      await this.api.axiosGql(type, p)
      .then( async(res) => {
        this.boardList = res.data
      }).catch( (err) => {
        console.log(err)
      }).finally( ()=> {
        this.loading = false
      })
    },
    async click(param) {
      const type = param.type
      if(type === 'edit') {
        const idx = param.idx
        if(confirm(`${this.t('sentence.isMod')}`)) router.push({name:"content", params:{idx: idx, type:param.contentType}})
      } else if(type === 'DELETE_BOARD') {
        if(confirm(`${this.t('sentence.isDel')}`)) {
          const idx = param.idx
          await this.api.axiosGql(type, {type:type, idx:idx})
          .then( async(res) => {
            if(res.status === 200) {
              this.boardList = []
              this.search()
            }
          }).catch( (err) => {
            console.log(err)
          }).finally( ()=> {
            this.loading = false
            alert(`${this.t('sentence.cmplDel')}`)
          })
        }
      }
    }
  }
}
</script>